import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgBoardPinBulk = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.973 5.454a.13.13 0 0 0-.126.08.17.17 0 0 0 .028.177c.566.644.89 1.483.89 2.352 0 1.476-1.184 2.534-2.584 2.62a.23.23 0 0 0-.208.191 2 2 0 0 1-3.946 0 .23.23 0 0 0-.208-.19c-1.4-.087-2.583-1.145-2.583-2.62 0-.87.325-1.71.89-2.355a.17.17 0 0 0 .028-.175.13.13 0 0 0-.126-.08c-2.79.076-4.653 2.074-4.653 5.028v6.105c0 3.013 1.935 5.038 4.816 5.038h7.615c2.882 0 4.819-2.025 4.819-5.038v-6.105c0-2.953-1.864-4.951-4.652-5.028"
      clipRule="evenodd"
      opacity={0.4}
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.661 18.723H8.342a.75.75 0 0 1 0-1.5h7.319a.75.75 0 0 1 0 1.5M9.39 13.865h5.223a.75.75 0 0 1 0 1.5H9.39a.75.75 0 1 1 0-1.5M10.273 7.445c.804-.449.956-.754 1.005-.852.22-.435.186-1.171.021-1.554-.036-.089-.148-.357-.692-.756a.24.24 0 0 1-.057-.256.24.24 0 0 1 .222-.152h2.455c.097 0 .186.06.221.149l.001.003c.035.087.012.19.016.194-.614.46-.727.726-.764.814-.165.388-.198 1.122.02 1.556.051.102.203.406 1.005.854.15.125.248.302.278.494H9.996a.82.82 0 0 1 .277-.494m-.409 1.994h1.386v1.105a.75.75 0 1 0 1.5 0V9.439h1.386c.76 0 1.378-.617 1.378-1.376a2.32 2.32 0 0 0-.922-1.845 1 1 0 0 0-.09-.058 4 4 0 0 1-.432-.275 2 2 0 0 1 .004-.218c.07-.068.202-.18.362-.306a1.73 1.73 0 0 0 .406-1.89 1.73 1.73 0 0 0-1.615-1.096h-2.455a1.73 1.73 0 0 0-1.615 1.098c-.26.657-.1 1.398.478 1.949.103.077.221.177.288.242.01.069.013.161.014.216-.1.076-.282.193-.44.28a1 1 0 0 0-.09.059 2.32 2.32 0 0 0-.92 1.844c0 .759.617 1.376 1.377 1.376"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgBoardPinBulk);
export default ForwardRef;
